module.exports = __webpack_public_path__ + "media/server_summary.8b46ffee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/server/server_summary.png
// module id = 744
// module chunks = 2